// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scrollsection{max-height:400px;overflow-y:scroll;padding-right:10px;padding-left:10px;margin-top:20px;position:relative;box-shadow:0 5px 7px -2px rgba(0,0,0,.5)}.scrollsection::-webkit-scrollbar{width:8px}.scrollsection::-webkit-scrollbar-track{background:#f0f0f0}.scrollsection::-webkit-scrollbar-thumb{background-color:#888;border-radius:4px}.button-wrapper{width:100%;display:block;text-align:center}", ""]);
// Exports
module.exports = exports;
